// extracted by mini-css-extract-plugin
export default {"unitList":"_ae2bb67e","unitWrapper":"_a70454ef","unitLabel":"_7e52f59a","unitAmount":"_b88ae410","rightLabels":"_d871646f","warnEnding":"_430a537f"};